import { FormField } from 'src/common/FormField';
import type {
  FormFieldControllerRulesProps} from 'src/common/FormField/FormFieldController';
import {
  FormFieldController
} from 'src/common/FormField/FormFieldController';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

const priceIntervalOptions: SelectOption[] = [
  {
    label: 'No interval',
    value: 'none',
  },
  {
    label: '$1',
    value: '1',
  },
  {
    label: '$5',
    value: '5',
  },
  {
    label: '$10',
    value: '10',
  },
];

export function PriceIntervalSelectField({
  fieldPath,
  rules,
}: {
  fieldPath: string;
  rules?: FormFieldControllerRulesProps;
}) {
  return (
    <FormFieldController name={fieldPath} rules={rules}>
      {({ field, fieldState }) => {
        return (
          <FormField
            error={fieldState?.error?.message}
            label="Price Rounding Interval"
            type="select"
            inputProps={{
              ...field,
              id: fieldPath,
            }}
            onChange={(option) => {
              field.onChange(option?.value === 'none' ? null : option?.value);
            }}
            options={priceIntervalOptions}
            value={
              field.value
                ? priceIntervalOptions.find(
                    // eslint-disable-next-line eqeqeq
                    (option) => option.value == field.value
                  )
                : priceIntervalOptions[0]
            }
            inline
            helperText="Select the interval to round prices to (e.g. $5 means prices will round to nearest $5)."
          />
        );
      }}
    </FormFieldController>
  );
}
